import React, { useState,useEffect } from 'react'
import { useSelector } from 'react-redux'
import Paiement from '../../components/paiement/Paiement'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useSnackbar } from 'notistack'
import CountDown from './CountDown'
import Alert from '@material-ui/lab/Alert'
import SportsTennisIcon from '@material-ui/icons/SportsTennis'

export default function PaiementTest(props) {
  const [count, setcount] = useState(60)
  const [open, setOpen] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const state = useSelector(state => state)
  const [payload, setpayload] = useState({
      
    'currency': 'EUR',
    // 'ipnTargetUrl': 'http://e3e8-164-177-46-201.ngrok.io/api/paiement/reservation',
    'ipnTargetUrl': process.env.REACT_APP_API_PATH+'api/paiement/reservation',
    'orderId':  `reservationTennis - ${state.user.numero}`,
    'customer': {
      'email': state.user.mail,
      'reference': state.user.numero,
      'billingDetails': {
        'firstName': state.user.prenom,
        'lastName': state.user.nom,
        'phoneNumber': state.user.additionalInfos?.LICI_TEL
      },
      'shoppingCart': {
        'cartItemInfo': [{
          'productLabel': `reservationTennis ${props.userInfo.rescre_id} ${props.userInfo.date} ${state.user.numero} - ${props.userInfo.guestNumero}` ,
        }]
      }
    },
    'metadata': {
      'userNumero' : props.userInfo.userNumero,
      'guestNumero' : props.userInfo.guestNumero,
      'rescre_id' : props.userInfo.rescre_id,
      'date' : props.userInfo.date
    },
  })
    
    
  const handleClickOpen = () => {
    setOpen(true)
  }
    
  const handleClose = () => {
    setOpen(false)
    props.deleteReservation(props.userInfo.rescre_id)
    props.onClose()
  }
    
  const checkPaiement = async () => { 
    var res = await props.callbackModal()
    if(res.variant !== 'error')
    {
      if(props.codeAdherent === '99999999')
        handleClickOpen()
      else{
        props.doReservation(true)
      }
    }
    else
      enqueueSnackbar(`${res.message}`, { variant: 'error' })
        
  }


    
  return (
    <div>
      <Button variant="outlined" color="primary" onClick={checkPaiement} disabled={props.codeAdherent === ''}>
            Valider
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"> <SportsTennisIcon/> Souscription  <CountDown onClose={handleClose} /> </DialogTitle>
        <Alert severity="warning">Veuillez rester sur la page et ne pas la recharger</Alert>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Paiement 
              onClose={handleClose}
              payload={payload}
              callback={props.callback}
              amount={props.amount}
            />
            <hr/>
                Paiement assuré par PayZen | Animanice 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Retour
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
    